import { MailOutlined, PhoneOutlined } from "@ant-design/icons"
import { Avatar, Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { friendlyContactRole } from "../helpers/contact-role.ts"
import type { PortalProjectManager } from "../types/portal.types.ts"

/** The real assigned-contact card — avatar, name, role, and working
 * email/phone actions. Shared by the Contact modal and the Messages page so
 * "no messaging yet" always resolves to the same honest, working
 * alternative rather than a dead end. */
export function ContactCard({ contact }: { contact: PortalProjectManager | null }) {
  const { t } = useTranslation()

  if (!contact) {
    return <p className="text-sm text-gray-500">{t("portal.contact.noContact")}</p>
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <Avatar src={contact.avatar || undefined} size={44}>
          {contact.first_name?.[0]}
        </Avatar>
        <div>
          <p className="font-medium text-gray-900">
            {[contact.first_name, contact.last_name].filter(Boolean).join(" ")}
          </p>
          <p className="text-xs text-gray-500">{friendlyContactRole(contact.role)}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {contact.email && (
          <Button icon={<MailOutlined />} href={`mailto:${contact.email}`}>
            {t("portal.contact.email")}
          </Button>
        )}
        {contact.phone && (
          <Button icon={<PhoneOutlined />} href={`tel:${contact.phone}`}>
            {t("portal.contact.call")}
          </Button>
        )}
      </div>
    </div>
  )
}
